(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trabalhe-conosco"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Função para tornar URLs clicáveis automaticamente
    function makeLinksClickable() {
      const footerText = document.querySelector('.careers-positions__footer-text');
      
      if (!footerText) return;
      
      // Regex para detectar URLs (http, https, www)
      const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/gi;
      
      // Processa cada parágrafo
      const paragraphs = footerText.querySelectorAll('p');
      
      paragraphs.forEach(function(p) {
        const originalText = p.innerHTML;
        
        // Substitui URLs por links clicáveis
        const newText = originalText.replace(urlRegex, function(url) {
          let href = url;
          
          // Adiciona https:// se começar com www
          if (url.startsWith('www.')) {
            href = 'https://' + url;
          }
          
          return '<a href="' + href + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
        });
        
        p.innerHTML = newText;
      });
    }
    
    // Executa quando o DOM estiver pronto
    makeLinksClickable();
  });

  } catch(e) { console.error(e); }
})();
})();
